/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon, Label } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { OrderItemQuantity } from '../OrderItemQuantity'
import { SubstitutionDeliverooDisclaimer } from '../SubstitutionDisclamer/SubstitutionDeliverooDisclaimer'
import { useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom-v5-compat'

const FulfillmentIssueLabel = ({orderItem}) => {
    const [t] = useTranslation();

    const queryClient = useQueryClient()
    const {id} = useParams()
    const order = queryClient.getQueryData(['orders', +id])

    const negativeCustomerAckType = ['SUBSTITUTION_REJECTED', 'NO_ANSWER_REJECTED'].includes(orderItem.customerAckType);
    const isPositiveIssue = ['REPLACEMENT_ITEM', 'PARTIAL_AVAILABILITY'].includes(orderItem.fulfillmentIssue) && !negativeCustomerAckType;

    return (
      <Label
        css={css`
                display: flex;
                align-items: baseline;
                column-gap: 1rem;
                justify-items: flex-end;
            `}
        size="mini"
        color={isPositiveIssue ? 'green' : 'grey'}>
          {t(`order.fulfillment_issue.${orderItem.fulfillmentIssue}`)}
          {orderItem.fulfillmentIssue === 'PARTIAL_AVAILABILITY' &&
            <>
                <Icon style={{ margin: '0 .5rem' }} name="long arrow alternate right"/>
                <OrderItemQuantity
                  orderItem={orderItem}
                  quantity={orderItem.quantity}
                />
            </>
          }
          {orderItem.fulfillmentIssue === 'REPLACEMENT_ITEM' &&
            <SubstitutionDeliverooDisclaimer
              css={css`margin-left: .5rem;`}
              initialPrice={order?.orderItems.find(oi => oi.id === orderItem.fulfillmentIssueParentId)?.initialTotalPrice}
              substitutedPrice={orderItem.initialTotalPrice}
            />
          }
      </Label>
    )
}

export { FulfillmentIssueLabel }
